import axios from 'axios';
import { getHeaders } from './CommonFunctions';

function httpRequest(url, requestType, data, onSuccess, onFailure) {
    let headers = getHeaders();

    let config = {
        method: requestType,
        url: url,
        headers: headers,
        data: data
    };

    return axios(config)
        .then(response => {
            onSuccess(response);
        })
        .catch(err => {
            err.response ? onFailure(err.response.data.message) : onFailure('An Unknown Error Occurred')
        });
}

export { httpRequest };